export const shouldSkipRequests = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  const { pathname } = window.location;
  return pathname.startsWith("/dev");
};
